import type { MapViewModule } from "../../@types/mapviewxs";

function sendToParentWindow(eventName: string, data?: Record<string, any>) {
  window.parent.postMessage({ name: eventName, ...data }, "*");
}

export const sendModelToParentWindow = (model?: MapViewModule): void => {
  if (!model) {
    return;
  }

  const { title, subtitle, infotip, closeOverlay } = model;
  sendToParentWindow("map-view", { title, subtitle, infotip, closeOverlay });
};

export const sendMapInitToParentWindow = (): void => {
  sendToParentWindow("map-view-initialized");
};

/**
 * Registers an event listener for a specific message event.
 *
 * @param eventName - The name of the event message to listen for.
 * @param callback - The function to call when the event is received. The callback receives a `MessageEvent` object as its argument.
 */
export const onMessage = (eventName: string, callback: (event: MessageEvent) => void) => {
  window.addEventListener(
    "message",
    (event) => {
      if (typeof event.data === "object" && event.data.name === eventName) {
        console.log(`MapViewFE received message event "${eventName}"`, event);
        callback(event);
      }
    },
    false,
  );
};
